import mixpanel from 'mixpanel-browser';
var MIXPANEL_TOKEN = process.env.REACT_APP_MIXPANEL_TOKEN || '';
export function identify(user, impersonator) {
    /* eslint-disable @typescript-eslint/camelcase */
    mixpanel.init(MIXPANEL_TOKEN, { cookie_name: 'card' });
    /* eslint-disable @typescript-eslint/camelcase */
    mixpanel.register({
        account_id: user.accountId,
        product: 'card',
        $email: user.email,
        'Impersonator Email': impersonator && impersonator.email,
        subscription_id: user.subscriptionId,
        'Contact Center': user.contactCenter
    });
    /* eslint-enable @typescript-eslint/camelcase */
    mixpanel.identify(user.email);
}
//eslint-disable-next-line @typescript-eslint/no-explicit-any
export function track(event, params) {
    //eslint-disable-next-line no-console
    console.log('*** MixPanel [', event, '] ***', params ? JSON.stringify(params) : '');
    mixpanel.track(event, params);
}
